'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.getDicts();
  }

  getDicts() {
    this.$http.get('/api/1/dictionaries').then(res => {
      this.dicts = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/1/dictionary/${id}`).then(res => {
        this.getDicts();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/dictionaries/list/list.controller.js